import { debug, george, observer, React, ui, pr } from "aaa";
import { ContactsStore } from "stores/ContactsStore";
import { MobilePhonesDropDown } from "./MobilePhonesDropDown";

export const ChoosePhoneDropdown = observer(({
    contactsStore,
    onNewPhone,
    onPhoneChanged
}: {
    contactsStore: ContactsStore,
    onNewPhone: () => void,
    onPhoneChanged?: (phoneId: string) => void,
}) => {
    const handleChangeSelection = (value: string) => {
        debug.log("### phone selected", value);
        contactsStore.selectedPhoneId = value;

        onPhoneChanged?.(value);
    };

    return (
        <MobilePhonesDropDown
            contactsStore={contactsStore}
            selectedPhoneId={contactsStore.selectedPhoneId}
            onSelectionChanged={handleChangeSelection}
            onNewPhone={onNewPhone}
            allowNewPhone
        />
    );
});

export const ChoosePhoneEmbedded = observer(({
    contactsStore,
    onNewPhone,
    description,
    onPhoneChanged
}: {
    contactsStore: ContactsStore,
    onNewPhone: () => void,
    description?: any,
    onPhoneChanged?: (phoneId: string) => void,
}) => (
        <>
            <george.SectionTitle>
                {ui.__("phone.title")}
            </george.SectionTitle>
            {description &&
                <george.SectionSubtitleTop>
                    {description}
                </george.SectionSubtitleTop>
            }
            <ChoosePhoneDropdown
                contactsStore={contactsStore}
                onNewPhone={onNewPhone}
                onPhoneChanged={onPhoneChanged}
            />
        </>
    )
);

export const ChoosePhone = observer(({
    contactsStore,
    onNewPhone,
    description,
    onPhoneChanged
}: {
    contactsStore: ContactsStore,
    onNewPhone: () => void,
    description?: any,
    onPhoneChanged?: (phoneId: string) => void,
}) => (
        <george.Card>
            <george.CardSectionTitle title={ui.__("phone.title")} />
            <george.CardSectionContent>
                {description &&
                    <george.SectionSubtitleTop>
                        {description}
                    </george.SectionSubtitleTop>
                }
                <ChoosePhoneDropdown
                    contactsStore={contactsStore}
                    onNewPhone={onNewPhone}
                    onPhoneChanged={onPhoneChanged}
                />
            </george.CardSectionContent>
        </george.Card>
    )
);

export const ChoosePhoneResponsive = observer(({
    contactsStore,
    onNewPhone,
    description,
    onPhoneChanged,
    icon
}: {
    contactsStore: ContactsStore,
    onNewPhone: () => void,
    description?: any,
    onPhoneChanged?: (phoneId: string) => void,
    icon?: React.ReactNode
}) => (
        <>
            {description &&
                <>
                    <george.SectionTitle style={{ marginTop: 0 }}>
                        {ui.__("phone.title")}
                    </george.SectionTitle>
                    <george.SectionSubtitleTop>
                        {description}
                    </george.SectionSubtitleTop>
                </>
            }
            <george.ResponsiveFormElement label={
                icon ?
                    <pr.HFlex style={{ alignItems: "center", gap: 8 }}>
                        {icon}
                        {ui.__("common.mobilePhone")}
                    </pr.HFlex>
                    : ui.__("common.mobilePhone")}
            >
                <ChoosePhoneDropdown
                    contactsStore={contactsStore}
                    onNewPhone={onNewPhone}
                    onPhoneChanged={onPhoneChanged}
                />
            </george.ResponsiveFormElement>
        </>
    )
);


// WEBPACK FOOTER //
// ./src/components/common/ChoosePhone.tsx